import {Store} from 'extensions/store/lib/store';

/**
 * @type {import('../types').MultiSystemStore}
 */
export const multiSystemStore = new Store({name: 'multi-system'});
